import { createAction } from '@reduxjs/toolkit';

export const getRecord = {
    request: createAction('record/get/request'),
    success: createAction('record/get/success'),
    failed: createAction('record/get/failed'),
};

export const createNewRecord = {
    request: createAction('record/createNew/request'),
    success: createAction('record/createNew/success'),
    failed: createAction('record/createNew/failed'),
};

export const updateRecord = {
    request: createAction('record/update/request'),
    success: createAction('record/update/success'),
    failed: createAction('record/update/failed'),
};

export const deleteRecord = {
    request: createAction('record/delete/request'),
    success: createAction('record/delete/success'),
    failed: createAction('record/delete/failed'),
};

export const checkActiveRecord = {
    request: createAction('record/checkActive/request'),
    success: createAction('record/checkActive/success'),
    failed: createAction('record/checkActive/failed'),
};

export const pauseRecord = {
    request: createAction('record/pause/request'),
    success: createAction('record/pause/success'),
    failed: createAction('record/pause/failed'),
};

export const resumeRecord = {
    request: createAction('record/resume/request'),
    success: createAction('record/resume/success'),
    failed: createAction('record/resume/failed'),
};

export const endRecord = {
    request: createAction('record/end/request'),
    success: createAction('record/end/success'),
    failed: createAction('record/end/failed'),
};

// Combined action: Update record and get next question
export const updateRecordAndGetNextQuestion = {
    request: createAction('record/updateAndGetNext/request'),
    success: createAction('record/updateAndGetNext/success'),
    failed: createAction('record/updateAndGetNext/failed'),
};

// Combined action: Create new record and get first question
export const createRecordAndGetFirstQuestion = {
    request: createAction('record/createAndGetFirst/request'),
    success: createAction('record/createAndGetFirst/success'),
    failed: createAction('record/createAndGetFirst/failed'),
};

// Combined action: Resume record and get current question
export const resumeRecordAndGetQuestion = {
    request: createAction('record/resumeAndGetQuestion/request'),
    success: createAction('record/resumeAndGetQuestion/success'),
    failed: createAction('record/resumeAndGetQuestion/failed'),
};

export const clearRecordError = createAction('record/clearError');

// New action for getting user section statistics
export const getUserSectionStats = {
    request: createAction('record/getUserSectionStats/request'),
    success: createAction('record/getUserSectionStats/success'),
    failed: createAction('record/getUserSectionStats/failed'),
};

// Action for getting monthly subject accuracy
export const getMonthlySubjectAccuracy = {
    request: createAction('record/getMonthlySubjectAccuracy/request'),
    success: createAction('record/getMonthlySubjectAccuracy/success'),
    failed: createAction('record/getMonthlySubjectAccuracy/failed'),
};

// Action for getting daily accuracy trend
export const getDailyAccuracyTrend = {
    request: createAction('record/getDailyAccuracyTrend/request'),
    success: createAction('record/getDailyAccuracyTrend/success'),
    failed: createAction('record/getDailyAccuracyTrend/failed'),
};
